import { Ray, Vector3 } from 'three';
import { KdTreeService } from '../../../3d/utils/kd-tree.service';
import { Point } from '../../../3d/utils/kd-tree/find-closest-points';
import { vectorToPoint } from '../../../3d/utils/point-cloud-utils';
import { PublicPart } from '../../../shared/misc-utilities/misc-utils';

export const defaultGroundZ = 0;

export class MockKdTreeService implements PublicPart<KdTreeService> {
  getGroundIntersection(ray: Ray) {
    return vectorToPoint(intersectRayWithZPlane(ray));
  }

  getGroundZ() {
    return defaultGroundZ;
  }

  getClosestPoint(ray: Ray) {
    return intersectRayWithZPlane(ray);
  }

  getClosestPoints(): Point[] {
    throw new Error(
      'Method not implemented. Should be used only in debugging mode.',
    );
  }

  getPointsWithinLocation() {
    return [];
  }
}

export function intersectRayWithZPlane(ray: Ray) {
  const scaleFactor = (defaultGroundZ - ray.origin.z) / ray.direction.z;

  return new Vector3().addVectors(
    ray.origin,
    ray.direction.multiplyScalar(scaleFactor),
  );
}
